import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import { isValidEmail } from "./emailUtils";
import styles from "./MultipleEmailInput.module.css";
import { Popover, ArrowContainer } from 'react-tiny-popover';
import IMAGES from "../../assets/images/images";

const Tooltip = ({ text }) => {
  let [isPopoverOpen, setIsPopoverOpen] = useState(false);
  return (
    <Popover
      isOpen={isPopoverOpen}
      positions={['top']} // preferred positions by priority
      containerClassName={styles.popoverContainer}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor={'#f5f3f3'}
          arrowSize={10}
          className='popover-arrow-container'
          arrowClassName='popover-arrow'
        >
          <div
            className={styles.tooltipBody}
          >
            {text}
          </div>
        </ArrowContainer>
      )}


    >
      <img src={IMAGES.infoCircle} className={styles.tooltipimg}
        onMouseLeave={() => setIsPopoverOpen((isPopoverOpen = false))}
        onMouseOver={() => setIsPopoverOpen((isPopoverOpen = true))}
      />

    </Popover>
  );
}

const MultipleEmailInput = ({
  name,
  label,
  placeholder = "Enter Email Addresses",
  disabled = false,
  isPreviewMode = false,
  isNote=false,
  requestorEmail = "",
  maxWidth="",
  ...props
}) => {
  const [field, meta] = useField(name);
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const emails = Array.isArray(field.value) ? field.value : [];
  const [inputValue, setInputValue] = useState("");
  const [localError, setLocalError] = useState("");

  const addEmail = async () => {
    const email = inputValue.trim();

    if (!email) {
      setLocalError("Please provide a valid email address.");
      return;
    }
    if (emails?.length >= 10) {
      setLocalError("Only 10 email addresses are allowed.");
      return;
    }

    if (!isValidEmail(email)) {
      setLocalError("Please enter a valid email address.");
      return;
    }
    if (email.toLowerCase() === requestorEmail?.toLowerCase()) {
      setLocalError("Requestor email address is not allowed.");
      return;
    }

    const exists = emails.some(
      (item) => item.toLowerCase() === email.toLowerCase()
    );

    if (exists) {
      setLocalError("This email address has already been added.");
      return;
    }

    const updatedEmails = [...emails, email];

    await setFieldValue(name, updatedEmails, true);
    await setFieldTouched(name, true, true);

    setInputValue("");
    setLocalError("");
  };

  const removeEmail = async (index) => {
    const updatedEmails = emails.filter((_, i) => i !== index);
    await setFieldValue(name, updatedEmails, true);
    await setFieldTouched(name, true, true);
  };

  const errorMessage = localError || (meta.touched && typeof meta.error === "string" ? meta.error : "");

  return (
    <div className={styles.wrapper}>
      {label && <label className={styles.label}>{label}</label>} {props.showTooltip && !isPreviewMode ? <Tooltip text={props.tooltipText} /> : <></>}

      {isPreviewMode ? (
        <div className={styles.emailContainer}>
          {emails?.length > 0 ? (
            emails?.map((email, index) => (
              <span key={index} className={styles.emailChip}>
                {email}
              </span>
            ))
          ) : (
            <span className={styles.emptyEmail}>---</span>
          )}
        </div>
      ) : (
        <>
          {emails.length > 0 && (
            <div className={styles.emailContainer}>
              {emails.map((email, index) => (
                <span
                  key={`${email}-${index}`}
                  className={styles.emailChip}
                >
                  {email}

                  <button
                    type="button"
                    className={styles.removeButton}
                    onClick={() => removeEmail(index)}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          )}

          <div
            className={`${styles.inputWrapper} ${styles[maxWidth]} ${errorMessage ? styles.inputWrapperError : ""
              }`}
          >
            <input
              type="text"
              value={inputValue}
              disabled={disabled}
              placeholder={placeholder}
              className={styles.input}
              onChange={(e) => {
                setInputValue(e.target.value?.toLocaleLowerCase());
                setLocalError("");
              }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); 
                    addEmail();
                  }
                }}
            />
            <img className={styles.addIcon} src={IMAGES.addicon} alt="add" onClick={addEmail} />
            {/* <button
              type="button"
              className={styles.addButton}
              onClick={addEmail}
            // disabled={!inputValue.trim()}
            >
              Add
            </button> */}
          </div>
          <div className={styles.errorContainer}>
            {errorMessage && (
              <div className={styles.errorText}>
                {errorMessage}
              </div>
            )}</div>
          {isNote?<div className={styles.notetxt}><span className={styles.notehead}>Note: </span>Enter up to 10 email addresses to receive ticket notifications and status updates.</div>:<></>}
        </>
      )}
    </div>
  );
};

export default MultipleEmailInput;